import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { PdModal, PdModalCloseButton, PdModalDescription, PdModalTitle } from "src/components/overlay";
import { tUseModal, useModal } from "src/providers/OverlayProvider";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { tModalComponentProps } from "src/redux/modals/types";
import { PdStack } from "src/components/layout";

type tConfirmModalParams = {
  title?: string;
  description?: string | (() => React.ReactNode);
  confirmButtonLabel?: string;
  hideCancelButton?: boolean;
};

export const ConfirmModal: React.FC<tModalComponentProps<tConfirmModalParams>> = ({
  onClose,
  onResolve,
  title,
  description,
  confirmButtonLabel,
  hideCancelButton,
}) => {
  const rIsMobile = useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );

  const handleOnClose = () => {
    onClose();
  };

  const handleOnConfirm = () => {
    onResolve();
  };

  return (
    <PdModal>
      <PdModalCloseButton onPress={handleOnClose} />
      <View style={styles.confirmModal}>
        <PdModalTitle style={styles.confirmModalTitle}>{title || "Confirm"}</PdModalTitle>
        {typeof description === "string" ? (
          <PdModalDescription>
            {description || "This action cannot be undone. Are you sure you want to do this?"}
          </PdModalDescription>
        ) : (
          description?.()
        )}
        <PdStack direction={rIsMobile ? "vertical" : "horizontal"} layout={[1, 1]} isReversed={rIsMobile}>
          {!hideCancelButton && (
            <PdButton colorScheme="purple" onPress={handleOnClose} variant="outline">
              <PdButtonLabel>Cancel</PdButtonLabel>
            </PdButton>
          )}
          <PdButton onPress={handleOnConfirm} style={rIsMobile ? { marginBottom: 2 * kStyleConst.kSpacing } : {}}>
            <PdButtonLabel>{confirmButtonLabel || "Confirm"}</PdButtonLabel>
          </PdButton>
        </PdStack>
      </View>
    </PdModal>
  );
};

const useConfirmModal = (): tUseModal<tConfirmModalParams> => {
  return useModal<tConfirmModalParams>(ConfirmModal);
};

export default useConfirmModal;

const styles = StyleSheet.create({
  confirmModal: {
    backgroundColor: kColors.white,
    maxWidth: 420,
    padding: 6 * kStyleConst.kSpacing,
  },
  confirmModalTitle: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
});
